import React, { useState, useEffect } from 'react';
import HeroStyle4 from '../Hero/HeroStyle4';
import Spacing from '../Spacing';
import SectionHeading from '../SectionHeading';
import FunFact from '../FunFact';
import { pageTitle } from '../../helpers/PageTitle';
import { Icon } from '@iconify/react';
import { BASE_URL, productAPI } from '../../services/api';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';

import KeyIngredients from '../KeyIngredients';
import Comparison from '../Comparison';
import Reviews from '../Reviews';
import Statistics from '../Statistics';
import AnimatedSection from '../AnimatedSection';

// import AboutStyle4 from '../About/AboutStyle4';
// import PortfolioSlider from '../Slider/PortfolioSlider';
// import PricingTableList from '../PricingTable/PricingTableList';
// import PostGridStyle2 from '../PostGrid/PostGridStyle2';
// import Marquee from '../Marquee';
// import Brands from '../Brands';
// import Cta from '../Cta';
// import TestimonialSlider from '../Slider/TestimonialSlider';
// const funfactData = [
//   { title: 'Happy Customers', number: '22k' },
//   { title: 'Work’s Completed', number: '15k' },
//   { title: 'Skilled Team Members', number: '121' },
//   { title: 'Most Valuable Awards', number: '15' },
// ];
// const postData = [
//   {
//     date: '05 Mar 2023',
//     title: 'How to keep fear from ruining your art business with confident',
//     thumbnailSrc: '/images/studio-agency/post_2.jpeg',
//     href: '/blog/blog-details',
//   },
//   {
//     date: '07 Mar 2023',
//     title: 'Artistic mind will be great for creation anything',
//     thumbnailSrc: '/images/studio-agency/post_1.jpeg',
//     href: '/blog/blog-details',
//   },
//   {
//     date: '03 Mar 2023',
//     title: 'How to keep fear from ruining your art business with confident',
//     thumbnailSrc: '/images/studio-agency/post_3.jpeg',
//     href: '/blog/blog-details',
//   },
//   {
//     date: '02 Mar 2023',
//     title: 'How to keep fear from ruining your art business with confident',
//     thumbnailSrc: '/images/studio-agency/post_4.jpeg',
//     href: '/blog/blog-details',
//   },
// ];
// const brandList = [
//   {
//     logoSrc: '/images/marketing-agency/brand_1.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_2.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_3.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_4.svg',
//     logoAlt: 'Brand',
//   },
// ];
// const brandListDark = [
//   {
//     logoSrc: '/images/marketing-agency/brand_1_dark.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_2_dark.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_3_dark.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_4_dark.svg',
//     logoAlt: 'Brand',
//   },
// ];
// const testimonialData = [
//   {
//     text: 'Zivans Motion Graphics did an excellent job on my video related projects. The motion graphics added an extra layer of polish and really brought the video to life. I highly recommend their high quality services and work.',
//     avatarName: 'Ansari Patron',
//     avatarDesignation: 'CEO at Delta',
//   },
//   {
//     text: 'Zivans Motion Graphics did an excellent job on my video related projects. The motion graphics added an extra layer of polish and really brought the video to life. I highly recommend their high quality services and work.',
//     avatarName: 'Jhon Doe',
//     avatarDesignation: 'Manager at Delta',
//   },
//   {
//     text: 'Zivans Motion Graphics did an excellent job on my video related projects. The motion graphics added an extra layer of polish and really brought the video to life. I highly recommend their high quality services and work.',
//     avatarName: 'Ramatam Coo',
//     avatarDesignation: 'MD at Delta',
//   },
// ];
// const portfolioData = [
//   {
//     thumbnailSrc: '/images/digital-agency/portfolio_1.jpeg',
//     miniTitle: 'React Development',
//     title: 'Corporate Webly <br />Application',
//     subTitle:
//       'From designing the user interface to coding the functionality and ensuring the <br /> website is secure and optimized for performance.',
//     href: '/portfolio/portfolio-details',
//   },
//   {
//     thumbnailSrc: '/images/digital-agency/portfolio_2.jpeg',
//     miniTitle: 'UI/UX Design',
//     title: 'eCommerce User <br />Interface Design',
//     subTitle:
//       'From designing the user interface to coding the functionality and ensuring the <br /> website is secure and optimized for performance.',
//     href: '/portfolio/portfolio-details',
//   },
//   {
//     thumbnailSrc: '/images/digital-agency/portfolio_3.jpeg',
//     miniTitle: '3D Render',
//     title: 'Multi Dimension <br />Two Square',
//     subTitle:
//       'From designing the user interface to coding the functionality and ensuring the <br /> website is secure and optimized for performance.',
//     href: '/portfolio/portfolio-details',
//   },
//   {
//     thumbnailSrc: '/images/digital-agency/portfolio_4.jpeg',
//     miniTitle: 'Animation',
//     title: 'Animated Abstract <br />3D Background',
//     subTitle:
//       'From designing the user interface to coding the functionality and ensuring the <br /> website is secure and optimized for performance.',
//     href: '/portfolio/portfolio-details',
//   },
// ];

export default function DigitalAgencyPage({ darkMode }) {
  pageTitle('Ayumedix Wellness Capsule');
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const sanitizeProductData = (data) => {
    if (!data) return data;
    const sensitiveTerms = [
      /male enhancement/gi,
      /performance enhancement/gi,
      /sexual wellness/gi,
      /sex drive/gi,
      /erection/gi,
      /libido/gi,
      /last longer/gi,
      /timing/gi,
      /intercourse/gi
    ];
    
    let sanitized = { ...data };
    const replacement = 'wellness';

    if (sanitized.product_name) {
      sensitiveTerms.forEach(term => {
        sanitized.product_name = sanitized.product_name.replace(term, 'Wellness');
      });
    }

    if (sanitized.short_description) {
      sensitiveTerms.forEach(term => {
        sanitized.short_description = sanitized.short_description.replace(term, replacement);
      });
    }

    if (sanitized.description) {
      sensitiveTerms.forEach(term => {
        sanitized.description = sanitized.description.replace(term, replacement);
      });
    }

    if (sanitized.other_description?.specifications) {
      const specs = sanitized.other_description.specifications;
      Object.keys(specs).forEach(key => {
        sensitiveTerms.forEach(term => {
          specs[key] = specs[key].replace(term, replacement);
        });
      });
    }

    return sanitized;
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await productAPI.getProducts();
        if (response.data.status === 200 && response.data.data.length > 0) {
          setProduct(sanitizeProductData(response.data.data[0]));
        }
      } catch (error) {
        // console.error('Error fetching product:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, []);

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm({
      ...contactForm,
      [name]: value
    });
    
    // Real-time validation
    const newErrors = { ...errors };
    
    if (name === 'name') {
      if (value.trim().length < 2) {
        newErrors.name = 'Name must be at least 2 characters';
      } else {
        delete newErrors.name;
      }
    }
    
    if (name === 'email') {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        newErrors.email = 'Please enter a valid email address';
      } else {
        delete newErrors.email;
      }
    }
    
    if (name === 'mobile') {
      const cleanPhone = value.replace(/[\s\-+]/g, '');
      if (!((/^[6-9]\d{9}$/.test(cleanPhone)) || (/^91[6-9]\d{9}$/.test(cleanPhone)))) {
        newErrors.mobile = 'Enter valid Indian mobile number (10 digits starting with 6-9)';
      } else {
        delete newErrors.mobile;
      }
    }
    
    setErrors(newErrors);
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    // console.log('Form submitted', contactForm);
    
    // Validation
    if (!contactForm.name.trim() || contactForm.name.length < 2) {
      toast.error('Name must be at least 2 characters');
      return;
    }
    if (!contactForm.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactForm.email)) {
      toast.error('Please enter a valid email address');
      return;
    }
    const cleanPhone = contactForm.mobile.replace(/[\s\-+]/g, '');
    if (!contactForm.mobile.trim() || !((/^[6-9]\d{9}$/.test(cleanPhone)) || (/^91[6-9]\d{9}$/.test(cleanPhone)))) {
      toast.error('Please enter a valid Indian mobile number (10 digits starting with 6-9)');
      return;
    }
    // if (!contactForm.message.trim() || contactForm.message.length < 10) {
    //   toast.error('Message must be at least 10 characters');
    //   return;
    // }

    // setSubmitting(true);
    try {
      // console.log('Sending request to API...');
      const response = await axios.post(`${BASE_URL}/contact/`, contactForm);
      // console.log('API response:', response);
      if (response.data.status === 201) {
        toast.success('Message sent successfully!');
        setContactForm({ name: '', email: '', mobile: '', message: '' });
      } else if(response.data.status===409) {
        toast.error('Failed to send message');
      }
    } catch (error) {
      // console.error('API error:', error);
      toast.error('Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
    <ToastContainer/>
    {/* <Spacing lg="120" md="80" /> */}
      <HeroStyle4
        title="Daily Wellness. Lasting Energy."
        subTitle="Step into a new level of balance and self-assurance with Ayumedix Wellness Capsules. Made with premium natural ingredients, this formula helps you feel more energetic, stay active, and maintain peak wellness throughout the day — so you can focus on life, not fatigue."
        thumbnailSrc={
          darkMode
            ? '/images/digital-agency/hero_bg_dark.jpeg'
            : '/images/digital-agency/hero_bg.jpeg'
        }
        videoSrc="https://www.youtube.com/embed/VcaAVWtP48A"
        bgUrl="/images/digital-agency/hero_video_bg.jpeg"
      />
      <Statistics />

      <section id="benefits" className="cs_primary_bg">
        <Spacing lg="120" md="80" />
        <div className="container">
          <FunFact colorVariant="cs_color_1" />
        </div>
        <Spacing lg="120" md="80" />
      </section>

      <section id="about" className="cs_shape_animation_2">
        <Spacing lg="120" md="80" />
        <div className="container">
          <div className="row align-items-center cs_gap_y_40">
            <div className="col-lg-6">
              <AnimatedSection animation="slideInLeft" delay={0.1}>
                <div className="cs_section_heading cs_style_1">
                <p className="cs_section_subtitle cs_accent_color cs_fs_18 mb-0 cs_semibold">
                  Total Men's Wellness
                </p>
                <Spacing lg="10" md="5" />
                <h2 className="cs_section_title cs_fs_50 mb-0">Reclaim Your Natural Energy & Wellness</h2>
                <div className="cs_section_subtitle mt-3">
                  <p>
                  Enhance energy, balance, and overall wellness with Ayumedix Wellness Capsules, a premium solution for men’s wellness. Designed to tackle the root causes of fatigue and promote daily vitality naturally.
                </p>
                <Spacing lg="30" md="20" />
                <ul className="cs_list cs_style_1 cs_mp0 cs_fs_18 cs_semibold" style={{ listStyle: 'none' }}>
                  <li className="d-flex align-items-center mb-3">
                    <span className="cs_accent_color me-3 cs_fs_24">✓</span> <span>Boosts daily energy levels</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <span className="cs_accent_color me-3 cs_fs_24">✓</span> <span>Supports an active lifestyle and physical wellness</span>
                  </li>
                  <li className="d-flex align-items-center mb-4">
                    <span className="cs_accent_color me-3 cs_fs_24">✓</span> <span>Promotes a balanced lifestyle and overall wellness</span>
                  </li>
                </ul>
                <Spacing lg="30" md="20" />
                <a
                  href="#product-section"
                  className="cs_btn cs_style_1 cs_fs_18 cs_rounded_5 cs_pl_40 cs_pr_40 cs_pt_20 cs_pb_20"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('product-section')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  style={{ boxShadow: '0 10px 20px rgba(104, 224, 207, 0.3)' }}
                >
                  <span>ORDER NOW</span>
                </a>
              </div>
              </div>
              </AnimatedSection>
            </div>
            <div className="col-lg-6">
              <AnimatedSection animation="slideInRight" delay={0.2}>
                <div className="position-relative ps-lg-5">
                <img src="/images/digital-agency/about-img.jpeg" alt="Ayumedix Wellness" className="w-100 cs_radius_15" style={{boxShadow: '0 20px 40px rgba(0,0,0,0.1)'}} />
                <div className="position-absolute" style={{bottom: '-20px', left: '20px', background: '#fff', padding: '20px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)'}}>
                  <div className="d-flex align-items-center gap-3">
                    <div className="cs_accent_bg text-white rounded-circle d-flex align-items-center justify-content-center" style={{width: '60px', height: '60px'}}>
                      <span className="cs_fs_20 cs_semibold">Pure</span>
                    </div>
                    <div>
                      <h4 className="mb-0 cs_fs_18 cs_semibold">Extracts</h4>
                      <p className="mb-0 cs_fs_14 text-muted">Ayurvedic Form</p>
                    </div>
                  </div>
                </div>
              </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
        <Spacing lg="120" md="80" />
      </section>

      {/* <AwarenessVideos /> */}

      <KeyIngredients />
      <Comparison />

      <section id="how-to-use" className="cs_primary_bg">
        <Spacing lg="120" md="80" />
        <div className="container">
          <div className="text-center">
            <SectionHeading
              title="Simple and effective <br />usage instructions"
              subTitle="How to Use"
              variantColor="cs_white_color"
            />
          </div>
          <Spacing lg="60" md="40" />
          <div className="row justify-content-center cs_gap_y_40">
            <div className="col-lg-4 col-md-6">
              <AnimatedSection animation="fadeUp" delay={0.1}>
                <div className="cs_iconbox cs_style_2 cs_radius_15 overflow-hidden" style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%'
                }}>
                  <div className="cs_iconbox_img" style={{ height: '250px', width: '100%', overflow: 'hidden' }}>
                    <img src="/images/digital-agency/step-1.jpeg" alt="Step 1" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div className="cs_iconbox_content" style={{ padding: '30px' }}>
                    <h2 className="cs_iconbox_title cs_white_color cs_semibold cs_fs_28 mb-3">
                      Step 1: Take the Capsule
                    </h2>
                    <p className="cs_iconbox_subtitle cs_white_color opacity-75 mb-4 cs_fs_16">
                      Take 1 capsule with lukewarm milk or water for optimal absorption and effectiveness.
                    </p>
                    <ul className="cs_iconbox_features cs_mp0 cs_white_color" style={{ listStyle: 'none', padding: 0 }}>
                      {[
                        'Use lukewarm milk for better results',
                        'Water is also acceptable',
                        'Take only 1 capsule per dose',
                        'Do not exceed recommended dosage',
                      ].map((item, index) => (
                        <li key={index} className="mb-2 d-flex align-items-start gap-2">
                          <span className="cs_accent_color">•</span>
                          <span className="opacity-80 cs_fs_14">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </AnimatedSection>
            </div>
            <div className="col-lg-4 col-md-6">
              <AnimatedSection animation="fadeUp" delay={0.2}>
                <div className="cs_iconbox cs_style_2 cs_radius_15 overflow-hidden" style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%'
                }}>
                  <div className="cs_iconbox_img" style={{ height: '250px', width: '100%', overflow: 'hidden' }}>
                    <img src="/images/digital-agency/step-2.jpeg" alt="Step 2" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div className="cs_iconbox_content" style={{ padding: '30px' }}>
                    <h2 className="cs_iconbox_title cs_white_color cs_semibold cs_fs_28 mb-3">
                      Step 2: Best Time to Take
                    </h2>
                    <p className="cs_iconbox_subtitle cs_white_color opacity-75 mb-4 cs_fs_16">
                      Consume 30 minutes after your morning or evening meal for maximum effectiveness and optimal results.
                    </p>
                    <ul className="cs_iconbox_features cs_mp0 cs_white_color" style={{ listStyle: 'none', padding: 0 }}>
                      {[
                        'Take 30 minutes after meal',
                        'Allow time for absorption',
                        'Maintain a healthy lifestyle',
                        'Consistent use improves results',
                      ].map((item, index) => (
                        <li key={index} className="mb-2 d-flex align-items-start gap-2">
                          <span className="cs_accent_color">•</span>
                          <span className="opacity-80 cs_fs_14">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </AnimatedSection>
            </div>
            <div className="col-lg-4 col-md-6">
              <AnimatedSection animation="fadeUp" delay={0.3}>
                <div className="cs_iconbox cs_style_2 cs_radius_15 overflow-hidden" style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%'
                }}>
                  <div className="cs_iconbox_img" style={{ height: '250px', width: '100%', overflow: 'hidden' }}>
                    <img src="/images/digital-agency/step-3.jpeg" alt="Step 3" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div className="cs_iconbox_content" style={{ padding: '30px' }}>
                    <h2 className="cs_iconbox_title cs_white_color cs_semibold cs_fs_28 mb-3">
                      Step 3: Be Consistent
                    </h2>
                    <p className="cs_iconbox_subtitle cs_white_color opacity-75 mb-4 cs_fs_16">
                      For best and long-lasting results, take the capsule daily without skipping for at least 30 days.
                    </p>
                    <ul className="cs_iconbox_features cs_mp0 cs_white_color" style={{ listStyle: 'none', padding: 0 }}>
                      {[
                        'Daily consumption is key',
                        'Visible results in 3-4 weeks',
                        'Safe for long term use',
                        'Do not skip days',
                      ].map((item, index) => (
                        <li key={index} className="mb-2 d-flex align-items-start gap-2">
                          <span className="cs_accent_color">•</span>
                          <span className="opacity-80 cs_fs_14">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
        <Spacing lg="120" md="80" />
      </section>
      <section id="product-section" className="cs_gray_bg cs_shape_animation_1">
        <Spacing lg="120" md="80" />
        <div className="container">
          <div className="text-center">
            <SectionHeading title="Premium Men's Wellness" subTitle="Product Spotlight" />
          </div>
          <Spacing lg="60" md="40" />
          <div className="row align-items-center cs_gap_y_40">
            <div className="col-lg-6">
              <div className="cs_product_thumb position-relative">
                <div className="cs_product_img cs_radius_15" style={{
                  height: '500px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                }}>
                  <img 
                    src='/images/digital-agency/product-img.jpeg' 
                    alt='Ayumedix Wellness Capsule'
                    className='cs_radius_15'
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="cs_product_info ps_lg_5">
                {loading ? (
                  <p>Loading product...</p>
                ) : product ? (
                  <>
                    <h2 className="cs_product_title cs_fs_56 cs_semibold mb-2">{product.product_name}</h2>
                    <p className="cs_product_subtitle cs_fs_20 cs_accent_color cs_semibold mb-4">{product.short_description}</p>
                    {/* <p className="cs_product_desc cs_fs_18 cs_height_line_1_7">{product.description}</p> */}
                    <Spacing lg="30" md="20" />
                    <div className="cs_product_price d-flex align-items-center cs_gap_15">
                      <span className="cs_price cs_fs_48 cs_semibold cs_accent_color">₹{product.price}</span>
                      <span className="cs_old_price cs_fs_24 text-muted text-decoration-line-through">₹2999</span>
                    </div>
                    <Spacing lg="35" md="25" />
                    <div className="cs_product_features mb-4">
                      {product.other_description?.specifications && Object.values(product.other_description.specifications).map((spec, index) => (
                        <div key={index} className="d-flex align-items-center mb-3">
                          <div className="cs_accent_color me-3 cs_fs_20">✓</div>
                          <span className="cs_fs_16">{spec}</span>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <p>Product not available</p>
                )}
                <Spacing lg="40" md="30" />
                <button 
                  onClick={() => {
                    if (product) {
                      localStorage.setItem('checkout_product', JSON.stringify(product));
                      window.location.href = '/checkout';
                    }
                  }}
                  className="cs_btn cs_style_1 cs_fs_20 cs_bold cs_rounded_5 cs_pl_50 cs_pr_50 cs_pt_20 cs_pb_20 overflow-hidden w-100 text-center"
                  style={{ boxShadow: '0 15px 30px rgba(104, 224, 207, 0.4)', transition: 'transform 0.3s ease' }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <span>ORDER NOW - FREE DELIVERY</span>
                </button>
                <Spacing lg="25" md="15" />
                
                <div className="d-flex justify-content-evenly cs_gap_20 mb-3 flex-wrap">
                  <div className="d-flex align-items-center">
                    <Icon icon="mdi:shield-check" className="cs_accent_color cs_fs_24 me-2" />
                    <span className="cs_fs_14 cs_semibold">SECURE CHECKOUT</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <Icon icon="mdi:leaf" className="cs_accent_color cs_fs_24 me-2" />
                    <span className="cs_fs_14 cs_semibold">PREMIUM NATURAL</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <Icon icon="mdi:truck-fast" className="cs_accent_color cs_fs_24 me-2" />
                    <span className="cs_fs_14 cs_semibold">FREE DELIVERY</span>
                </div>
                
                <div className="text-center mt-4 pt-4" style={{ borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                  <p className="cs_fs_14 cs_semibold mb-3 d-flex align-items-center justify-content-center">
                    <Icon icon="mdi:certificate" className="cs_accent_color me-2 cs_fs_20" />
                    Tested by AYUSH Approved & ISO Certified Lab
                  </p>
                  <a href="/R-250216-04%20Man%20Power.pdf" target="_blank" className="d-inline-flex align-items-center cs_btn cs_style_1 cs_fs_14 cs_semibold cs_rounded_5 px-4 py-2" style={{ background: '#f8f9fa', color: '#0b5e4b', border: '1px solid #0b5e4b', transition: 'all 0.3s ease' }} onMouseOver={(e) => { e.currentTarget.style.background = '#0b5e4b'; e.currentTarget.style.color = '#fff'; }} onMouseOut={(e) => { e.currentTarget.style.background = '#f8f9fa'; e.currentTarget.style.color = '#0b5e4b'; }}>
                    <Icon icon="mdi:file-certificate-outline" className="me-2 cs_fs_20" />
                     VIEW LAB REPORT (COA)
                  </a>
                </div>
                
                {/* <div className="cs_disclaimer cs_fs_14 cs_ternary_color text-center opacity-75 mt-2">
                  <strong>Quality:</strong> Certified Authentic Ayurvedic Formulation. <br/>
                  <small>This product is not intended to diagnose, treat, cure, or prevent any disease. Results may vary from person to person.</small>
                </div> */}
              </div>
            </div>
            </div>
          </div>
        </div>
        <Spacing lg="120" md="80" />
      </section>

      {/* Trust & Quality Assurance Section */}
      <section className="cs_primary_bg position-relative overflow-hidden">
        <Spacing lg="100" md="60" />
        <div className="container position-relative z-index-1">
          <div className="row align-items-center cs_gap_y_40">
            <div className="col-lg-6">
              <AnimatedSection animation="slideInLeft">
                <div className="d-flex align-items-start mb-4">
                  <div className="cs_accent_bg rounded px-3 py-1 mb-3 d-inline-block">
                    <span className="text-dark cs_semibold cs_fs_14">100% TRANSPARENCY</span>
                  </div>
                </div>
                <h2 className="cs_white_color cs_fs_48 cs_semibold mb-3">
                  Tested for Purity <br/>and Potency
                </h2>
                <p className="cs_white_color opacity-75 cs_fs_18 mb-4">
                  We believe in complete transparency. Ayumedix Wellness is tested by an independent, AYUSH Approved and ISO 9001:2015 Certified Laboratory.
                </p>
                <ul className="cs_list cs_style_1 cs_mp0 cs_fs_16 cs_white_color mb-5" style={{ listStyle: 'none' }}>
                  <li className="d-flex align-items-center mb-3">
                    <div className="cs_accent_color me-3 cs_fs_24"><Icon icon="mdi:check-circle" /></div>
                    <span className="opacity-90">pH Balanced (2% w/v Aq. Sol.)</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <div className="cs_accent_color me-3 cs_fs_24"><Icon icon="mdi:check-circle" /></div>
                    <span className="opacity-90">Verified Water & Alcohol Soluble Extractives</span>
                  </li>
                  <li className="d-flex align-items-center mb-4">
                    <div className="cs_accent_color me-3 cs_fs_24"><Icon icon="mdi:check-circle" /></div>
                    <span className="opacity-90">Meets strict Phytochemical Analysis standards</span>
                  </li>
                </ul>
                <a href="/R-250216-04%20Man%20Power.pdf" target="_blank" className="cs_btn cs_style_1 cs_fs_16 cs_semibold cs_rounded_5 cs_pl_30 cs_pr_30 cs_pt_15 cs_pb_15 d-inline-flex align-items-center">
                  <Icon icon="mdi:download" className="me-2 cs_fs_20" />
                  DOWNLOAD FULL LAB REPORT
                </a>
              </AnimatedSection>
            </div>
            <div className="col-lg-6 position-relative text-center">
              <AnimatedSection animation="zoomIn" delay={0.2}>
                <div className="position-relative d-inline-block">
                  <div className="cs_iconbox cs_style_2 cs_radius_15 overflow-hidden text-start" style={{
                    background: 'rgba(255, 255, 255, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    padding: '40px',
                    maxWidth: '400px',
                    margin: '0 auto',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
                  }}>
                    <Icon icon="mdi:certificate-outline" className="cs_accent_color mb-3" style={{ fontSize: '60px' }} />
                    <h3 className="cs_white_color cs_fs_24 cs_semibold mb-2">Certificate of Analysis</h3>
                    <p className="cs_white_color opacity-75 cs_fs_14 mb-4">Official Lab Report: TR-R-0298/0225</p>
                    
                    <div className="d-flex align-items-center mb-2 pb-2" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                      <span className="cs_white_color opacity-50 cs_fs_14 w-50">Report Date</span>
                      <span className="cs_white_color cs_semibold cs_fs_14 w-50 text-end">27/02/2025</span>
                    </div>
                    <div className="d-flex align-items-center mb-2 pb-2" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                      <span className="cs_white_color opacity-50 cs_fs_14 w-50">Appearance</span>
                      <span className="cs_white_color cs_semibold cs_fs_14 w-50 text-end">Hard Gelatin Capsule</span>
                    </div>
                    <div className="d-flex align-items-center mb-0">
                      <span className="cs_white_color opacity-50 cs_fs_14 w-50">Result</span>
                      <span className="cs_accent_color cs_semibold cs_fs_14 w-50 text-end d-flex align-items-center justify-content-end">
                        <Icon icon="mdi:check-decagram" className="me-1" /> Approved
                      </span>
                    </div>
                  </div>
                  
                  {/* Decorative Elements */}
                  <div className="position-absolute" style={{ top: '-30px', right: '-30px', zIndex: -1 }}>
                    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="50" cy="50" r="50" fill="#68E0CF" opacity="0.1" />
                      <circle cx="50" cy="50" r="30" fill="#68E0CF" opacity="0.2" />
                    </svg>
                  </div>
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
        
        {/* Background shapes */}
        <div className="position-absolute" style={{ top: '0', left: '0', width: '100%', height: '100%', opacity: '0.05', zIndex: 0, pointerEvents: 'none' }}>
           <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
             <defs>
               <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                 <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#FFFFFF" strokeWidth="1"/>
               </pattern>
             </defs>
             <rect width="100%" height="100%" fill="url(#grid)" />
           </svg>
        </div>
        <Spacing lg="100" md="60" />
      </section>

      <Reviews />

      {/* Contact Section */}
      <section id="contact" className="cs_primary_bg">
        <Spacing lg="143" md="75" />
        <div className="container">
          <div className="text-center">
            <SectionHeading
              title="Get in touch for more <br/>information and support"
              subTitle="Contact Us"
              variantColor="cs_white_color"
            />
          </div>
          <Spacing lg="75" md="60" />
          <div className="row align-items-center cs_gap_y_45">
            <div className="col-lg-6">
              <h2 className="cs_fs_50 cs_white_color">
                Have questions about <br />
                Ayumedix Wellness?
              </h2>
              <div className="cs_height_55 cs_height_lg_30" />
              <ul className="cs_mp0 cs_contact_info">
                <li>
                  <h3 className="cs_fs_29 cs_semibold cs_white_color">Email:</h3>
                  <p className="mb-0 cs_white_color">support@ayumedix.com</p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold cs_white_color">WhatsApp:</h3>
                  <p className="mb-0 cs_white_color"><a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>+91 93139 89270</a></p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold cs_white_color">Address:</h3>
                  <p className="mb-0 cs_white_color">Gondal, Gujarat, India</p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold cs_white_color">Support Hours:</h3>
                  <p className="mb-0 cs_white_color">Mon-Sat: 9 AM - 8 PM IST</p>
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="cs_contact_form_wrap">
                <div className="cs_gray_bg_3 cs_contact_form_bg" style={{borderRadius: "15px"}} />
                <form className="cs_contact_form" onSubmit={handleContactSubmit}>
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Your full name
                  </label>
                  <input
                    name="name"
                    value={contactForm.name}
                    onChange={handleContactChange}
                    placeholder="Type your name"
                    type="text"
                    className="cs_form_field"
                    required
                  />
                  {errors.name && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{errors.name}</div>}
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Email address
                  </label>
                  <input
                    name="email"
                    value={contactForm.email}
                    onChange={handleContactChange}
                    placeholder="Type your email address"
                    type="email"
                    className="cs_form_field"
                    required
                  />
                  {errors.email && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{errors.email}</div>}
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Phone number
                  </label>
                  <input
                    name="mobile"
                    value={contactForm.mobile}
                    onChange={handleContactChange}
                    placeholder="Type your phone number"
                    type="tel"
                    className="cs_form_field"
                    required
                  />
                  {errors.mobile && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{errors.mobile}</div>}
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Your message
                  </label>
                  <textarea 
                    name="message"
                    value={contactForm.message}
                    onChange={handleContactChange}
                    cols={30} 
                    rows={5} 
                    className="cs_form_field"
                    placeholder="Ask about Ayumedix Wellness, wellness, or any concerns..."
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <button type="submit" className="cs_btn cs_style_1" disabled={submitting}>
                    {submitting ? 'Sending...' : 'Send Message'}{' '}
                    <span>
                      <i><Icon icon="fa6-solid:arrow-right" /></i>
                      <i><Icon icon="fa6-solid:arrow-right" /></i>
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Spacing lg="143" md="75" />
      </section>
      
    </>
  );
}
// {/* <section className="cs_gray_bg_2 cs_shape_animation_2">
//   <div className="cs_shape_1 position-absolute">
//     <svg
//       width={57}
//       height={41}
//       viewBox="0 0 57 41"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         opacity="0.5"
//         d="M55.1923 32.7347C52.209 37.0618 42.704 43.3879 40.3199 34.8097C39.0585 30.2359 42.6536 24.5172 43.1266 19.9687C43.8204 13.2821 39.973 5.41874 32.4359 6.05135C31.8886 6.10385 31.3452 6.19047 30.8086 6.31072C29.5308 4.21019 27.6918 2.5107 25.5002 1.40489C23.3085 0.299087 20.8519 -0.168816 18.4087 0.0542238C11.0797 0.743766 5.31489 7.39247 2.40097 13.6616C0.297443 17.9159 -0.0470809 22.831 1.44227 27.3386C2.02253 28.9897 4.52649 28.3381 4.07868 26.6111C2.33789 19.994 6.55742 12.4976 11.1238 7.99978C15.6903 3.50194 23.1517 2.572 26.8919 7.71511C22.3191 9.96086 18.2321 14.1614 15.6019 17.957C12.4483 22.5245 9.15598 31.3746 15.1794 35.2589C21.0135 39.0165 27.7181 36.5241 30.9852 30.8306C34.3217 24.9727 34.2461 16.9828 32.6377 10.6251C32.4379 9.84013 32.1764 9.07227 31.8556 8.32873C34.7948 7.65817 37.6078 8.80319 39.4747 11.7765C42.4517 16.502 40.9317 21.6009 39.5126 26.5289C38.1691 31.1785 36.6617 38.618 42.9185 40.5728C48.4057 42.2935 54.6246 38.6054 56.4853 33.2978C56.7691 32.507 55.6275 32.1085 55.1923 32.7347ZM27.8253 28.0345C26.6396 30.7231 24.5519 32.7537 21.5181 32.9751C16.3336 33.3547 15.3434 29.0909 16.4723 25.0739C18.1122 19.3298 23.2274 13.4845 28.1407 10.0684C28.1664 10.1199 28.1896 10.1727 28.2101 10.2266C30.2749 16.0071 30.1378 22.349 27.8253 28.0345Z"
//         fill="#4F4747"
//       />
//     </svg>
//   </div>
//   <div className="cs_shape_2 position-absolute">
//     <svg
//       width={21}
//       height={24}
//       viewBox="0 0 21 24"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         opacity="0.5"
//         d="M1.83883 0.992714L20.9086 13.6609L0.402728 23.8417L1.83883 0.992714Z"
//         fill="#4F4747"
//       />
//     </svg>
//   </div>
//   <div className="cs_height_143 cs_height_lg_75" />
//   <div className="container">
//     <SectionHeading
//       title="Offering budget friendly pricing <br /> solutions for your business"
//       subTitle="Our Pricing"
//     />
//     <Spacing lg="85" md="45" />
//   </div>
//   <div className="container">
//     <PricingTableList />
//   </div>
//   <div className="cs_height_150 cs_height_lg_80" />
// </section>
// <TestimonialSlider
//   layeredImages={[
//     '/images/digital-agency/layer_img_1.png',
//     '/images/digital-agency/layer_img_2.png',
//     '/images/digital-agency/layer_img_3.png',
//     '/images/digital-agency/layer_img_4.png',
//     '/images/digital-agency/layer_img_5.png',
//   ]}
//   data={testimonialData}
// />
// <Cta
//   title="Is there a specific project or goal <br/>that you have in mind?"
//   btnText="Contact Us"
//   btnUrl="/contact"
//   bgUrl="/images/creative-agency/cta_bg.jpeg"
//   variant="cs_type_1"
// />
// <section className="cs_shape_animation_3">
//   <div className="cs_shape_1 position-absolute">
//     <svg
//       width={509}
//       height={458}
//       viewBox="0 0 509 458"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <circle cx={254} cy={229} r="228.5" stroke="currentColor" />
//       <circle
//         cx={26}
//         cy={237}
//         r="25.5"
//         className="anio_3_c_1"
//         fill="white"
//         stroke="currentColor"
//       />
//       <circle cx={26} cy={237} r={15} fill="currentColor" />
//       <circle
//         cx={483}
//         cy={229}
//         r="25.5"
//         className="anio_3_c_1"
//         fill="white"
//         stroke="currentColor"
//       />
//       <circle cx={483} cy={229} r={15} fill="currentColor" />
//     </svg>
//   </div>
//   <Spacing lg="143" md="75" />
//   <div className="container">
//     <SectionHeading title="Some recent news" subTitle="Our Blog" />
//     <Spacing lg="85" md="45" />
//     <PostGridStyle2 data={postData} />
//   </div>
// </section>
// <Spacing lg="135" md="70" />
// <Marquee text="We Create Design - Build App - Website - Branding - SEO" />
// <Spacing lg="84" md="50" />
// <div className="container">
//   <Brands data={darkMode ? brandListDark : brandList} />
// </div>
// <Spacing lg="135" md="80" /> */}
